/**
 * @prettier
 */
export function openUrl(pathname: string): void {
    window.location.assign(pathname);
}
